<div mat-dialog-title>
      <div class="d-flex flex-row">
        <h1 class="form-title-heading flex-grow-1">{{title ? title : 'Detail'}}</h1>
        <a (click)="this.close()" class="clickable ms-3">
          <img src="/assets/cancel-icon-alt.png" alt="cancel-icon" />
        </a>
      </div>
  </div>
  

<div mat-dialog-content class="row border-table">
    <div class="col-12 col-md-12">
        <table class="table table-borderless table-responsive">
            <tbody>
                <ng-container *ngFor="let key of dialogDataFields">
                    <ng-container  *ngFor="let item of dataArr">
                        <tr *ngIf="item[key.fieldName] && !key.attachment && !key.statusField && !key.tableView && !key.eLink">
                            <td scope="row" class="headings">{{key.label ? key.label : ''}}</td>
                            <td scope="row" class="colon">:</td>
                            <td scope="row" class="ps-lg-5 break">
                                {{item[key.fieldName] ? item[key.fieldName] : 'N/A'}}</td>
                        </tr>
                        <tr *ngIf="item[key.fieldName] && !key.attachment && key.statusField && !key.tableView && !key.eLink">
                          <td scope="row" class="headings">{{key.label ? key.label : ''}}</td>
                          <td scope="row" class="colon">:</td>
                          <td scope="row" class="ps-lg-5 break">
                            <div
                            style="width: fit-content !important;"
                            class="view-action-buttons"
                            [ngClass]="{
                              'approve': item[key.fieldName] == ModifiedActionStatus.APPROVED,
                              'pending' : item[key.fieldName] == ModifiedActionStatus.PENDING,
                              'rejected': item[key.fieldName] == ModifiedActionStatus.REJECTED,
                              'closed': item[key.fieldName] == ModifiedActionStatus.CLOSED,
                              'canceled': item[key.fieldName] == ModifiedActionStatus.CANCELED,
                              'complete': item[key.fieldName] == ModifiedActionStatus.COMPLETE,
                              'open': item[key.fieldName] == ModifiedActionStatus.OPEN ,
                              'paid' : item[key.fieldName] == ModifiedActionStatus.PAID,
                              'in-progress': item[key.fieldName] == ModifiedActionStatus.INPROGRESS,
                              'discuss-hr' : item[key.fieldName] == ModifiedActionStatus.DISCUSSWITHHR
                            }"
                            >
                                <span class="btn-text">{{item[key.fieldName] ? item[key.fieldName] : "N/A"}}</span>
                            </div>
                        </tr>
                        <tr *ngIf="item[key.fieldName] && key.html && !key.attachment && !key.statusField && !key.tableView && !key.eLink">
                          <td scope="row" class="headings" style="background-color:Red;">{{key.label ? key.label : ''}}</td>
                          <td scope="row" class="colon">:</td>
                          <td scope="row" class="ps-lg-5 break">
                            <div [innerHtml]="item[key.fieldName] ? item[key.fieldName] : 'N/A'"></div>
                          </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>

    <div class="col-12 col-md-12 mb-4">
      <ng-container *ngFor="let key of dialogDataFields">
        <ng-container *ngFor="let item of dataArr">
          <div *ngIf="item[key.fieldName] && key.attachment && !key.statusField && !key.tableView">
          <h1 class="form-title-heading-2">{{key.label}}</h1>
          <div class="file-container">
            <a (click)="previewImage(item[key.fieldName])" class="image-link clickable">
              <div class="d-flex flex-row justify-content-start align-self-center">
                <div class="flex-grow-1 me-4">
                  <!-- <p class="img-title">{{item[key.fieldName] && assetsPathUrl ? assetsPathUrl + item[key.fieldName] : 'N/A'}}</p> -->
                  <p class="img-title mb-0">Download document</p>
                </div>
                <img src="/assets/menu-icon/downlaod-icon.png" alt="download-icon" style="width: 25px; height: 25px; object-fit: contain;">
              </div>
            </a>
          </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div class="col-12 col-md-12 mb-4">
      <ng-container *ngFor="let key of dialogDataFields">
        <ng-container *ngFor="let item of dataArr">
          <div *ngIf="item[key.fieldName] && key.eLink && !key.statusField && !key.tableView">         
          <div class="file-container">   
            <p class="inside-label">{{key.label}}</p>
            <a (click)="openeLink(item[key.fieldName])" class="image-link clickable">      
              <div class="d-flex flex-row justify-content-start align-self-center">
                <div class="flex-grow-1 me-4">
                  <p class="img-title mb-0">{{item[key.fieldName]}}</p>
                </div>                
              </div>
            </a>
          </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <ng-container *ngFor="let key of dialogDataFields">
      <ng-container *ngFor="let item of dataArr">
        <ng-container *ngIf="item[key.fieldName] && key.tableView && key.tableDataFields && key.tableData">
          <div class="col-12 col-md-12 mb-4">
            <h1 class="form-title-heading-2">{{key.label ? key.label : ""}}</h1>
            <intrasense-table-ui 
              [dataFields]="key.tableDataFields" 
              [dataSource]="key.tableData">
            </intrasense-table-ui>
          </div>
        </ng-container>
      </ng-container>
  </ng-container>
    <ng-container *ngIf="dialogDataFields">
  <div *ngIf="data.actions?.length" class="mt-4 d-flex gap-2 mb-4 justify-content-end">
    <ng-container *ngFor="let action of data.actions">
    <button 
      *ngIf="action.condition"
      mat-flat-button class="btn-large"
      [ngClass]="'btn-' + (action.type || 'primary')"
      (click)="action.action()">{{ action.label }}
    </button>
  </ng-container>
  </div>
  </ng-container>
</div>